import { Injectable } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AdminAssetsService {
    private readonly basePath = '/assets/app/modules/admin/assets/svg/';

    constructor(
        private http: HttpClient,
        private sanitizer: DomSanitizer
    ) { }

    /**
     * Gets the full URL for an SVG asset in the admin module
     */
    getSvgUrl(filename: string): string {
        return `${this.basePath}${filename}`;
    }

    /**
     * Loads an SVG file and returns it as a sanitized HTML string for use in templates
     */
    loadSvg(filename: string): Observable<SafeHtml> {
        return this.http.get(`${this.basePath}${filename}`, { responseType: 'text' })
            .pipe(
                map(svg => this.sanitizer.bypassSecurityTrustHtml(svg))
            );
    }

    /**
     * Returns an inline SVG as a sanitized HTML for direct binding
     * Uses synchronous XMLHttpRequest (note: synchronous requests are deprecated)
     */
    getInlineSvg(filename: string): SafeHtml {
        const url = `${this.basePath}${filename}`;
        const request = new XMLHttpRequest();
        request.open('GET', url, false); // false makes the request synchronous
        request.send(null);

        if (request.status === 200) {
            let svg = request.responseText;
            // Inject width and height if missing (for Safari compatibility)
            if (svg.startsWith('<svg')) {
                // Only add if not present
                if (!/width=/.test(svg) || !/height=/.test(svg)) {
                    // Try to extract viewBox for default size
                    const viewBoxMatch = svg.match(/viewBox=["'](\d+)[^ ]* (\d+)[^ ]* (\d+)[^ ]* (\d+)["']/);
                    let width = '24', height = '24';
                    if (viewBoxMatch) {
                        width = viewBoxMatch[3];
                        height = viewBoxMatch[4];
                    }
                    // Add width/height attributes after <svg ...
                    svg = svg.replace(/<svg([^>]*)/i, `<svg$1 width=\"${width}\" height=\"${height}\"`);
                }
            }
            return this.sanitizer.bypassSecurityTrustHtml(svg);
        }

        console.error(`Failed to load SVG: ${url}`);
        return this.sanitizer.bypassSecurityTrustHtml('');
    }
}
